module.exports = __webpack_public_path__ + "img/09.d1a37916.jpg";